import React, { Component } from 'react';

export default class UnityModal extends Component {
  constructor(props) {
    super(props);
    this.modalRef = React.createRef();
  }

  componentDidMount() {
    this.updateProperties();
  }

  componentDidUpdate() {
    this.updateProperties();
  }

  updateProperties() {
    const { props, modalRef } = this;
    const unityModal = modalRef.current;
    const { toggle } = props;
    if (unityModal) {
      unityModal.toggle = toggle || (() => {});
    }
  }

  render() {
    const {
      show,
      cancelOnOutsideClick,
      top,
      body,
      bottom,
      title,
      modalTitle,
      ...otherProps
    } = this.props;

    const modalProps = { ...otherProps };
    if (show) modalProps.show = show;
    if (cancelOnOutsideClick) modalProps.cancelOnOutsideClick = cancelOnOutsideClick;

    return (
      <unity-modal
        ref={this.modalRef}
        modalTitle={title || modalTitle}
        {...modalProps}
      >
        {!!top && (
          <div slot="top">
            {top}
          </div>
        )}
        {!!body && (
          <div slot="body">
            {body}
          </div>
        )}
        {!!bottom && (
          <div slot="bottom">
            {bottom}
          </div>
        )}
      </unity-modal>
    );
  }
}
//
// UnityModal.propTypes = {
//   modalTitle: PropTypes.string,
//   show: PropTypes.bool,
//   toggle: PropTypes.func,
//   cancelOnOutsideClick: PropTypes.bool,
//   top: PropTypes.any,
//   body: PropTypes.any,
//   bottom: PropTypes.any,
// };